import { render, staticRenderFns } from "./AddtionalSetting.vue?vue&type=template&id=4ccf9c73"
import script from "./AddtionalSetting.vue?vue&type=script&lang=js"
export * from "./AddtionalSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports